import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { MouseEvent } from 'react';
import { StyleObj } from '../../../../@types';
import useLocalization from '../../../../hooks/useLocalization';

type BetslipPlaceBetButtonProps = {
  totalStakeAmount: number;
  maxPayout: number;
  isDisabled: boolean;
  isLoading: boolean;
  bonusPercentage?: number;
  minWinningAmount?: number | null;
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
  onPointerDown?: (event: MouseEvent<HTMLButtonElement>) => void;
};

const styles: StyleObj = {
  placeBetButton: {
    minHeight: 48,
    height: 48,
    flex: 1,
    borderRadius: 0,
    px: 1,
    backgroundColor: '#082c47',
    ':disabled': {
      backgroundColor: 'neutral.500',
      color: 'neutral.300',
    },
  },
};

const BetslipPlaceBetButton = ({
  totalStakeAmount,
  maxPayout,
  isDisabled,
  bonusPercentage = 0,
  minWinningAmount,
  onClick,
  onPointerDown,
}: BetslipPlaceBetButtonProps) => {
  const { t } = useLocalization();
  const showWinning = totalStakeAmount > 0;
  const showRange = typeof minWinningAmount === 'number';

  return (
    <Button
      disableRipple
      fullWidth
      type='submit'
      sx={styles.placeBetButton}
      disabled={isDisabled}
      onClick={onClick}
      onPointerDown={onPointerDown}
    >
      <Stack
        sx={{
          alignItems: 'center',
        }}
      >
        <Typography
          variant='h3'
          sx={{
            fontWeight: 400,
          }}
        >
          {t('placeBet')}
        </Typography>
        {showWinning && (
          <Typography
            variant='body3'
            color={isDisabled ? 'neutral.200' : '#74d600'}
            sx={{
              lineHeight: 1,
            }}
          >
            {showRange ? (
              <>
                {t('betslipMin')} {minWinningAmount.toFixed(2)} → {t('betslipMax')} {maxPayout.toFixed(2)}
              </>
            ) : (
              <>
                {t('toReturn')} {maxPayout.toFixed(2)}
              </>
            )}
            {bonusPercentage > 0 && ` (${bonusPercentage}%)`}
          </Typography>
        )}
      </Stack>
    </Button>
  );
};

export default BetslipPlaceBetButton;
